export default __webpack_public_path__ + "static/media/closed-ranking.debb1b24.mp3";